<template>
    <div>
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-download" @click="Download_template">下载模板</el-button>
                <el-button icon="el-icon-document" type="primary" @click="Import_users">导入名单</el-button>
                <el-button icon="el-icon-refresh" type="primary" @click="Refreash_users">刷新</el-button>
                <el-dialog title="上传文件" :visible.sync="dialogFormVisible_upload" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                    <!-- 这里给子组件传递了getUserInfo方法，供子组件调用 -->
                    <upload ref="upload_file" :getRCUserInfo="getUserInfo" :task_id="task_id"></upload>
                    <div style="margin-top:10px;">
                        <el-button @click="dialogCancel_upload">取消</el-button>
                        <el-button type="primary" @click="uploadFile">立即上传</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="search" style="float:right;">
                <!-- 通过在form上添加@submit.native.prevent，可以支持在input上添加@keyup.native.enter，否则直接添加回车事件会有问题 -->
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
    <el-table
    :data="user_list"
    border
    style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="job_num" label="工号" min-width="6%"></el-table-column>
        <el-table-column prop="real_name" label="姓名" min-width="6%">
            <template slot-scope="scope">
                <span style="font-weight:bold;">{{ scope.row.real_name }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="email" label="公司邮箱" min-width="15%"></el-table-column>
        <el-table-column prop="plate_system" label="当前板块体系" min-width="10%"></el-table-column>
        <el-table-column prop="department" label="当前部门" min-width="10%"></el-table-column>
        <el-table-column prop="superior_name" label="直属上级姓名" min-width="9%"></el-table-column>
        <el-table-column prop="superior_email" label="直属上级邮箱" min-width="15%"></el-table-column>
        <el-table-column prop="staff_type" label="管理层/员工" min-width="8%"></el-table-column>
        <el-table-column prop="operations" label="操作" min-width="11%">
            <template slot-scope="scope">
                <!-- <el-button
                size="mini"
                @click="handleEdit(scope.row.id)">编辑</el-button> -->
                <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row.id)">删除</el-button>
                <el-button
                size="mini"
                type="warning"
                @click="resetPasswd(scope.row.id)">重置密码</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div style="margin-top:10px;" v-if="user_list.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageinfo.current"
            :page-sizes="pageinfo.page_sizes"
            :page-size="pageinfo.page_size"
            layout="total, sizes, prev, pager, next"
            :total="pageinfo.count">
        </el-pagination>
    </div>
    </div>   
</template>

<script>
import upload from "../UpLoad.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.getUserInfo();
    },
    components: {
        upload
    },
    data() {
        return {
            // tips: 'peer评估人和下级评估人，至少配置3个以上。',
            dialog_tips: '评估人姓名和邮箱请确保按序一一对应，多个姓名或邮箱请使用英文逗号分隔。',
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            user_list: [],
            dialogFormVisible_resetpasswd: false,
            reset_username: '',
            reset_user_list: [],
            dialogFormVisible_company: false,
            dialogFormVisible_upload: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {

            },
            opertion: 'edit',
            disable_flag: true,
            dialog_title: '',
            template_file: {
                file_name: 'rc-user_template.xlsx'
            },
            add_special_user_title: '',
            add_special_user_type: '',
        }
    },
    props: ['task_id'],
    methods: {
        resetPasswd(id) {
            this.$confirm("确认重置该用户的密码么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    user_id: id,
                    task_id: this.task_id,
                }
                getdata.getListP("resetRCUserPasswd", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: "密码重置成功！重置后的密码为该用户的公司邮箱",
                                type: "success",
                            })
                            this.getUserInfo();
                        }else{
                            this.$message({
                                message: "密码重置失败！",
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                        // loading.close();
                    })
                    .catch(() => {
                        this.$message({
                            message: "用户删除失败！",
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    });
            }).catch(() => {
                
            })
        },
        handleDelete(id) {
            // 这里的rows是传的整个表格的数据，网上说的用scope.row不行
            // 还是换成从后台删除，然后传最新的数据过来渲染
            // rows.splice(index, 1); 
            this.$confirm("确认删除该用户么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    user_id: id,
                    task_id: this.task_id,
                }
                getdata.getListP("deleteRCUser", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: "用户已删除！",
                                type: "success",
                            })
                            this.getUserInfo();
                        }else{
                            this.$message({
                                message: "用户删除失败！",
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                        // loading.close();
                    })
                    .catch(() => {
                        this.$message({
                            message: "用户删除失败！",
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    });
            }).catch(() => {
                
            })
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            if(this.formInline.search_info==''){
                this.getUserInfo();
            }else{
                this.getUserInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            if(this.formInline.search_info==''){
                this.getUserInfo();
            }else{
                this.getUserInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        Import_users() {
            this.dialogFormVisible_upload = true;
        },
        Refreash_users() {
            this.getUserInfo();
            this.$message({
                message: "刷新完成！",
                type: "success",
            })
        },
        getUserInfo(id, query_info) {
            id = id||-1;      // 设置参数默认值为-1
            query_info = query_info||'';
            // const loading = this.$loading({
            //     lock: true, // lock的修改符--默认是false
            //     text: '正在加载，请稍后...', // 显示在加载图标下方的加载文案
            //     spinner: 'el-icon-loading', // 自定义加载图标类名
            //     background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            // })
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                query_info: query_info,
                user_id: id,
                task_id: this.task_id,
            }
            
            getdata.getListP("getRCUserInfo", params)
            .then(resp => {
                // console.log(resp);
                if(resp.data.code == 200){
                    if(id==-1){
                        this.user_list = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }else{
                        // 因为form是字典，所以要使用data[0]赋值
                        this.form = resp.data.data[0];
                    }  
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
        dialogCancel_upload() {
            this.dialogFormVisible_upload = false;
        },
        uploadFile() {
            // 调用子组件的上传方法，结合传参，可以自由地指定后台接口
            this.$refs.upload_file.uploadFile('importRCUsers');
            this.dialogFormVisible_upload = false;
            // 这里不能直接使用getUserInfo()方法加载已导入的问卷，得在子组件中调用父组件的该方法完成加载
            // this.getUserInfo();
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        search() {
            // console.log('this.pageinfo.current: ' + this.pageinfo.current);
            this.getUserInfo(-1, this.formInline.search_info);
        },
    }
}
</script>

<style scoped>
/* .el-table {
    font-size: 18px;
} */
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
/* .el-button {
    font-size: 18px;
} */
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 18px;
}
.search /deep/ .el-input__inner {
    height: 45px;
    line-height: 45px;
}
::v-deep .el-pagination span, ::v-deep .el-pagination button, ::v-deep .el-pager li {
    font-size: 18px;
    line-height: 45px;
    height:45px;
}
::v-deep .el-pagination__sizes .el-input .el-input__inner, ::v-deep .el-select .el-input .el-select__caret {
    font-size: 18px;
} */
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 640px;
}
/* ::v-deep .el-input--mini .el-input__icon {
    line-height: 45px;
} */
::v-deep .el-form-item {
    margin-bottom: 0;
}
/* ::v-deep .el-table__header {
    font-size: 16px;
} */
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
.company_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.company_form /deep/ .el-input {
    width: 320px;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
::v-deep .el-button--mini {
    padding: 6px 5px;
}
</style>